import { useEffect, useMemo, useState } from 'react';
import { listStateDevice } from './socket/query';

export const useRecentCameras = ({ cameras, namespace, enabled = true }) => {
  const [loading, setLoading] = useState(false);
  const [cached, setCached] = useState({});

  const serials = useMemo(() => {
    return cameras.map((camera) => camera.serial);
  }, [cameras]);

  const serialsToFetch = useMemo(() => {
    return serials.filter((serial) => !cached[serial]);
  }, [serials, cached]);

  const serialsStr = useMemo(() => {
    return serialsToFetch.join(';');
  }, [serialsToFetch]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!serialsStr) {
      return;
    }

    const fetchCameras = async () => {
      setLoading(true);

      const cameras = await listStateDevice({ serials: serialsStr, namespace });

      const newCached = cameras.reduce((acc, camera) => {
        acc[camera.serial] = camera;

        return acc;
      }, {});

      setCached((prev) => ({ ...prev, ...newCached }));
      setLoading(false);
    };

    fetchCameras();
  }, [serialsStr, namespace, enabled]);
  

  const camerasResult = useMemo(() => {
    return cameras.map((camera) => cached[camera.serial] || camera).filter(Boolean);
  }, [cameras, cached]);

  return {
    loading,
    cameras: camerasResult,
  };
};
